import React from 'react';
import ReactDOM from 'react-dom';
import { X, CheckCircle, XCircle, AlertTriangle, Info } from 'lucide-react';
import { useNotificationStore } from '../../store/notificationStore';
import './NotificationAction.css';

const ICON = {
  success: CheckCircle,
  error:   XCircle,
  warning: AlertTriangle,
  info:    Info,
};

const NotificationItem = ({ notification, onClose }) => {
  const type = notification.type || 'info';
  const Icon = ICON[type] || Info;

  return (
    <div className={`notif-item notif-item--${type}`}>
      <Icon className="notif-icon" />

      <div className="notif-body">
        {notification.title && (
          <p className="notif-title">{notification.title}</p>
        )}
        <p className="notif-msg">{notification.message}</p>
      </div>

      {/* Optional one-click action (e.g. Undo). Absent on every existing
          notification, which therefore renders exactly as before. */}
      {notification.action && (
        <button
          type="button"
          className="notif-action"
          onClick={() => {
            notification.action.onClick?.();
            onClose(notification.id);
          }}
        >
          {notification.action.label}
        </button>
      )}

      <button
        className="notif-close"
        onClick={() => onClose(notification.id)}
        aria-label="Dismiss"
      >
        <X size={13} />
      </button>
    </div>
  );
};

const NotificationContainer = () => {
  const { notifications, removeNotification } = useNotificationStore();

  if (notifications.length === 0) return null;

  // Portal into document.body so it escapes any stacking context created by
  // the modal backdrop's backdrop-filter (WebKit / Tauri WKWebView issue).
  return ReactDOM.createPortal(
    <div className="notif-stack">
      {notifications.map((n) => (
        <NotificationItem key={n.id} notification={n} onClose={removeNotification} />
      ))}
    </div>,
    document.body
  );
};

export default NotificationContainer;
